module.exports = __webpack_public_path__ + "static/media/comb-scissors-duo.83fde2e1.svg";